import React, { Component } from 'react';
import SelectField from '../../../components/forms/SelectField';
import BreadCrumb from './BreadCrumb';

class SubHeader extends Component {
    componentDidMount() {
        this.props.fetchOptions();
    }
    _selectContext = value => {
        this.props.switchContext(value);
    };
    render() {
        return (
            <header className="ckp-admin-header-sub">
                <div className="ckp-admin-header-sub-left">
                    {this.props.contextReady ? (
                        <SelectField
                            onChange={this._selectContext}
                            className="ckp-admin-header-sub-select"
                            items={this.props.organizations}
                            label=""
                            name="context"
                            value={this.props.subject}
                        />
                    ) : null}
                </div>
                <div className="ckp-admin-header-sub-right">
                    <BreadCrumb
                        breadcrumb={this.props.breadcrumb}
                        contextId={this.props.subject}
                        contextName={this.props.contextName}
                    />
                </div>
            </header>
        );
    }
}

export default SubHeader;
